module.exports = __webpack_public_path__ + "static/media/question-2.f045f06f.svg";